import { connect } from 'react-redux'
import firebase from 'firebase/app'
import { userSelector } from '../../../store/selectors/baseSelectors'
import { planSelector } from '../../../store/selectors/selectors'
import { withFormik } from 'formik'
import { compose, branch, renderNothing } from 'recompose'
import { emailRegex } from 'variables'
import { smallScreenSelector } from '../../../store/selectors/boardSelectors';

export default compose(
  connect(state => ({
    user: userSelector(state),
    plan: planSelector(state),
    smallScreen: smallScreenSelector(state)
  })),
  branch(({ user }) => !user.displayName, renderNothing),
  withFormik({
    mapPropsToValues: ({ user }) => ({
      displayName: user.displayName,
      email: user.email
    }),

    validate: values => {
      const errors = {}

      if (!values.displayName) {
        errors.displayName = 'settings.errors.nameRequired'
      }

      if (!values.email) {
        errors.email = 'settings.errors.emailRequired'
      } else if (!values.email.match(emailRegex)) {
        errors.email = 'settings.errors.emailInvalid'
      }

      return errors
    },

    handleSubmit: async (
      values,
      {
        setSubmitting,
        resetForm,
        setFieldTouched,
        setFieldError,
      }
    ) => {
      const user = firebase.auth().currentUser

      let updateName
      if (values.displayName !== user.displayName) {
        updateName = user
          .updateProfile({
            displayName: values.displayName
          })
          .then(() =>
            firebase
              .database()
              .ref(`/users/${user.uid}`)
              .update({
                displayName: values.displayName,
                'public/displayName': values.displayName
              })
          )
          .then(() => true)
      }

      let updateEmail
      if (values.email !== user.email) {
        updateEmail = user
          .updateEmail(values.email)
          .then(() =>
            firebase
              .database()
              .ref(`/users/${user.uid}`)
              .update({ email: values.email })
          )
          .then(() => true)
          .catch(error => {
            switch (error.code) {
              case 'auth/user-not-found':
                setFieldError('email', 'settings.errors.other')
                break
              case 'auth/invalid-email':
                setFieldError('email', 'settings.errors.emailInvalid')
                break
              case 'auth/email-already-in-use':
                setFieldError('email', 'settings.errors.emailInUse')
                break
              case 'auth/requires-recent-login':
                setFieldError('email', 'settings.errors.requiresRecentLogin')
                break
              default:
                break
            }
            return false
          })
      }

      const nameSaved = await updateName
      const emailSaved = await updateEmail

      setSubmitting(false)
      if (nameSaved) setFieldTouched('name', false)
      if (emailSaved) setFieldTouched('email', false)
      if (nameSaved !== false && emailSaved !== false) resetForm()
    },

    displayName: 'SettingsForm'
  })
)
